import { Navigate, Route, Routes } from 'react-router-dom';
import { OrgListPage } from './org-list-page';

export function SuperAdminRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="organisations" replace />} />
      <Route path="organisations" element={<OrgListPage />} />
      <Route path="*" element={<Navigate to="organisations" replace />} />
    </Routes>
  );
}
